import { environment } from 'src/environments/environment';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogTemplateComponent } from '@optsolservices/ngx-confirm-dialog';
import { BaseService } from 'src/app/core/services/base.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { PrintTriggerDialogComponent } from 'src/app/shared/print-trigger-dialog/print-trigger-dialog.component';
import { PosTfgAccountPayWithMoneyEquipmentComponent } from '../components/pos-tfg-account-pay-with-money-equipment/pos-tfg-account-pay-with-money-equipment.component';
import { SendEmailConfirmDialogComponent } from '../components/send-email-confirm-dialog/send-email-confirm-dialog.component';
import { TfgPaymentReversalComponent } from './tfg-payment-reversal/tfg-payment-reversal.component';

@Component({
  selector: 'app-tfg-account',
  templateUrl: './tfg-account.component.html',
  styleUrls: ['./tfg-account.component.scss']
})
export class TfgAccountComponent implements OnInit {
  form: FormGroup;
  tfgAccountDetails: any = null;
  stores = [];
  transactions = [];
  idDocumentVerified = false;

  constructor(
    private fb: FormBuilder,
    private baseService: BaseService,
    private dialog: MatDialog,
  ) {
    this.form = fb.group({
      storeId: [null, Validators.compose([Validators.required])],
      tfgCardNumber: [null, Validators.compose([Validators.required, Validators.minLength(19), Validators.maxLength(19), Validators.pattern('[0-9]+')])],
      trackTwo: [null]
    });
  }

  ngOnInit() {
    this.baseService.executeCommand<any>('portal_tfg_account_config', {})
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.stores = response.data || []
        } else {
          this.stores = [];
        }

        if (this.stores.length > 0) {
          this.form.controls['storeId'].setValue(this.stores[0].storeId);
        }
      });
  }

  validate() {
    this.tfgAccountDetails = null;

    const dialogData: OiGroupDialogData = {
      title: 'Validating TFG Credit Card',
      function: 'portal_oi_group_payment_validate_tfg_card',
      postBody: Object.assign(this.form.getRawValue(), { portalProcess: 'QUERY' })
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px'
    });

    ref.afterClosed().subscribe(oiResult => {
      if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
        this.baseService.executeCommand<any>('portal_pos_payment_tfg_validation_details', oiResult.data).subscribe(detailResponse => {
          if (detailResponse.responseCode === 0) {
            this.form.disable();
            this.tfgAccountDetails = detailResponse.data;


            if (this.idDocumentVerified === false && this.tfgAccountDetails.accountStatusCode === 21) {
              const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
                width: '450px',
                data: {
                  title: `${this.tfgAccountDetails.accountStatusCode} - ${this.tfgAccountDetails.accountStatus}`,
                  text: 'IMPORTANT: Please verify the ID document of the customer.',
                  confirmButtonText: 'I have verified the ID Document',
                  cancelButtonText: '',
                  showConfirmButton: true,
                  showCancelButton: false
                }
              });

              dialogRef.afterClosed().subscribe(result => {
                this.idDocumentVerified = true;
              });
            }

            this.baseService.executeCommand<any>('portal_tfg_account_transactions', { requestId: this.tfgAccountDetails.requestId }).subscribe(transactionsResponse => {
              if (transactionsResponse.responseCode === 0) {
                this.transactions = transactionsResponse.data;
              }
            });
          }
        });


      }
    });
  }

  reset() {
    this.tfgAccountDetails = null;
    this.transactions = [];
    this.form.controls['tfgCardNumber'].reset();
    this.form.controls['trackTwo'].reset();
    this.form.enable();
    this.idDocumentVerified = false;
  }

  payAccount(subType: string) {
    const ref = this.dialog.open(PosTfgAccountPayWithMoneyEquipmentComponent, {
      data: Object.assign(this.tfgAccountDetails, { subType: subType }),
      width: '800px'
    });

    ref.afterClosed().subscribe(response => {
      this.validate();
    });
  }

  openTfgCustomerPortal() {
    window.open(environment.tfgCustomerPortal, '_blank');
  }

  openTfgNewAccountPortal() {
    window.open(environment.tfgStoreApplicationPortal, '_blank');
  }

  openTfgCardReplenPortal() {
    window.open(environment.tfgCardReplenPortal, '_blank');
  }


  checkForTfgCardScan(event, value: string) {
    if (value) {
      const regex = new RegExp(`^;[0-9]{19}=[0-9]{17}\\?$`);
      if (regex.test(value)) {
        const cardPieces = value.split('=');
        const cardNumber = cardPieces[0].replace(';', '');
        this.form.controls['tfgCardNumber'].setValue(cardNumber);
        this.form.controls['trackTwo'].setValue(value);
        this.validate();
      } else {
        this.form.controls['trackTwo'].setValue(null);
      }

    }
  }

  generateDocument(document: any) {
    const ref = this.dialog.open(PrintTriggerDialogComponent, {
      data: {
        title: 'Generating TFG Payment Receipt',
        function: 'portal_tfg_account_create_print_trigger',
        postBody: document
      },
      width: '600px'
    });

    ref.afterClosed().subscribe(response => {
      this.validate();
    });
  }

  emailDocument(emailInfo: any) {
    const dialogRef = this.dialog.open(SendEmailConfirmDialogComponent, {
      width: '450px',
      data: {
        createEmailFunction: 'portal_tfg_account_create_email',
        email: emailInfo,
        form: {
          name: '',
          email: ''
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.validate();
    });
  }

  downloadResource(resource: any) {
    this.baseService.downloadResource(resource.apiResourceKey, resource.fileName, resource.mimeType);
  }

  showEmailDetails(dataItem: any, index: number) {
    return dataItem.emails ? true : false;
  }

  reversePayment(dataItem: any) {
    const dialogRef = this.dialog.open(TfgPaymentReversalComponent, {
      width: '900px',
      data: dataItem
    });

    dialogRef.afterClosed().subscribe(result => {
      this.validate();
    });
  }
}
